import { IGif } from "services/types";

export const filterGifsList = (prevGifs: IGif[], newGifs: IGif[]) => {
  const previousIds = prevGifs.map(gif => gif.id);
  return [
    ...prevGifs,
    ...newGifs.filter(gif => previousIds.indexOf(gif.id) === -1)
  ];
};
